/**
 * "Failed to execute 'removeChild' on 'Node': The node to be removed is not a child of this node" (e 'insertBefore').
 *
 * O React guarda referências aos nós de texto/elementos que ele criou. Quando algo FORA do React troca ou envolve esses nós
 * (tradução automática do navegador, extensões que mexem no texto, leitores de tela), a próxima atualização tenta remover um
 * nó que já não está ali e o React derruba a tela inteira ("Algo não saiu como esperado"). O nó que ele quer tirar já saiu do
 * lugar, então ignorar a chamada é seguro e mantém a tela de pé.
 *
 * É o contorno conhecido do React para esse caso (facebook/react#11538). Só age quando o nó realmente não é filho: nas
 * chamadas normais, o comportamento do navegador é o original.
 */
let installed = false;

export const installDomMutationGuard = (): void => {
  if (installed || typeof Node !== 'function' || !Node.prototype) return;
  installed = true;

  const originalRemoveChild = Node.prototype.removeChild;
  Node.prototype.removeChild = function <T extends Node>(this: Node, child: T): T {
    if (child && child.parentNode !== this) {
      console.warn('[dom-guard] removeChild ignorado: o nó já não está neste pai (provável tradução do navegador ou extensão).');
      return child;
    }
    return originalRemoveChild.call(this, child) as T;
  };

  const originalInsertBefore = Node.prototype.insertBefore;
  Node.prototype.insertBefore = function <T extends Node>(this: Node, newNode: T, referenceNode: Node | null): T {
    if (referenceNode && referenceNode.parentNode !== this) {
      console.warn('[dom-guard] insertBefore ignorado: o nó de referência já não está neste pai (provável tradução do navegador ou extensão).');
      return newNode;
    }
    return originalInsertBefore.call(this, newNode, referenceNode) as T;
  };
};
